module.exports = __webpack_public_path__ + "static/img01-a49a7f905b9c1e3c26d5be88969ac0c3.jpg";